<template>
  <v-layout>
    <v-flex v-if="reportsPending">
      <v-flex>
        Getting client location fulfillment entries...
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-flex>
    <v-flex v-else>
      <v-layout column full-width>
        <v-layout row align-center>
          <h1 class="display-1 mr-2">Period:</h1>
          <template>
            <v-flex>
              <v-menu
                ref="startDateMenu"
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="Start Date"
                    format="dddd, MM DD YYYY"
                    @change="value => startDate = value"
                    :value="dateFormatted(startDate)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :show-current="endDate"
                  v-model="startDate"
                  @input="startDateMenu = false"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
          <template>
            <v-flex>
              <v-menu
                ref="endDateMenu"
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="End Date"
                    format="dddd, MM DD YYYY"
                    @change="value => endDate = value"
                    :value="dateFormatted(endDate)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :show-current="startDate"
                  v-model="endDate"
                  @input="endDateMenu = false"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
          <v-btn @click="reGetRecords" color="primary">
            Change Dates
          </v-btn>
        </v-layout>

        <v-data-table
          :items="report"
          :headers="headers"
          item-key="worksite_id"
          class="elevation-1"
        >
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td>
              {{ item.location_name }}
              </td>
              <td>
                {{ item.shifts_requested }}
              </td>
              <td>
                {{ item.shifts_fulfilled }}
              </td>
              <td>
                {{ Math.round(item.fulfillment_percent * 100, 2) }}%
              </td>
            </tr>
          </template>
        </v-data-table>

      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  import {ExportToCsv} from 'export-to-csv';

  export default {
    components: {},
    computed: {
      ...mapState('userAuth', ['user']),
      //computedOffset: function () {
      //  return this.limit * (this.page - 1)
      //},
      //pageLength: function () {
      //  return Math.ceil(this.queryTotal / this.limit)
      //},
      formattedQuery: function() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          //limit: this.limit,
          //offset: this.computedOffset,
          //page: this.page,
        };
      },
      shiftsByBusiness: function() {
        let businesses = [];
        this.shifts.forEach(s => {
          if (
            // haven't seen this business yet, create it.
            businesses.filter(b => b.id == s.client_business_id).length < 1
          ) {
            businesses.push({
              name: s.client_business,
              id: s.client_business_id,
              locations: [],
            });
          }

          if (
            // havent' seen this location yet, create it.
            businesses
              .find(b => b.id == s.client_business_id)
              .locations.filter(l => l.id == s.location_id).length < 1
          ) {
            businesses
              .find(b => b.id == s.client_business_id)
              .locations.push({
                name: s.location,
                id: s.location_id,
                shifts: [],
              });
          }

          // have the business and the location. add this shift to the location's collection
          businesses
            .find(b => b.id == s.client_business_id)
            .locations.find(l => l.id == s.location_id)
            .shifts.push(s);
        });

        return businesses;
      },
      sortedShifts: function() {
        return this.shifts.sort((a, b) => {
          let nameA = a.client_business.toLowerCase();
          let nameB = b.client_business.toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
      },
    },
    created() {
      this.setUp();
    },
    watch: {
      //'page': {
      //  handler(value) {
      //    if (value != this.$route.query.page) {
      //      this.reGetRecords()
      //    } else {
      //    }
      //  }
      //}
    },
    data: function() {
      return {
        limit: 40,
        page: 1,
        startDateMenu: false,
        endDateMenu: false,
        startDate: this.$moment()
          .subtract(2, 'weeks')
          .format('YYYY-MM-DD'),
        endDate: this.$moment()
          .subtract(1, 'weeks')
          .format('YYYY-MM-DD'),
        reportsPending: true,
        loadingCsv: false,
        report: {},
        //defaultSort: {
        //  sortBy: 'order',
        //  rowsPerPage: -1, //all
        //},
        headers: [
          { text: 'Location', value: 'location_name', sortable: true },
          { text: 'Shifts Requested', value: 'shifts_requested', sortable: true },
          { text: 'Shifts Fulfilled', value: 'shifts_fulfilled', sortable: true },
          { text: 'Fulfillment Percent', value: 'fulfillment_percent', sortable: true },
        ],
      };
    },

    methods: {
      setUp: function() {
        this.startDate = this.$route.query.startDate || this.startDate;
        this.endDate = this.$route.query.endDate || this.endDate;

        this.getReports();
      },

      // TODO:
      generateCsv: function(report) {
        const options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: false,
          filename: `billing-report_${this.$moment(this.startDate).format(
            'YYYY-MM-DD',
          )}--${this.$moment(this.endDate).format('YYYY-MM-DD')}`,
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
        };

        const exportedFormat = report.map(s => {
          const row = {};

          row['Parent client'] = s.client_business;

          row['Client location'] = s.location;

          row['Service'] = 'Staffing';

          row['Position'] = s.position;

          row['Dif'] = s.dif;

          row['Employee'] = s.worker;

          row['Date'] = this.$moment(s.start_datetime).format('YYYY-MM-DD');

          row['Quantity'] = s.hours_worked;

          row['Client-added bonus'] = s.bonuses
            .filter(b => b.type == 'Client-added')
            .map(b => b.amount);
          row['Travel bonus'] = s.bonuses
            .filter(b => b.type == 'Travel')
            .map(b => b.amount);
          row['Call-in bonus'] = s.bonuses
            .filter(b => b.type == 'Call-in')
            .map(b => b.amount);

          // TODO: Cancellation columns

          return row;
        });

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(exportedFormat);
        this.loadingCsv = false;
      },

      csvExport: function() {
        this.loadingCsv = true;
        this.$store
          .dispatch('reports/getClientFulfillmentReport', {
            startDate: this.startDate,
            endDate: this.endDate,
          })
          .then(report => {
            this.generateCsv(report);
          })
          .catch(err => {
            console.log(err);
          })
          .finally(r => {
            this.loadingCsv = false;
          });
      },

      dateFormatted: function(date) {
        return date ? this.$moment(date).format('dddd, MMMM D') : '';
      },

      getReports: function() {
        this.reportsPending = true;
        this.$store
          .dispatch('reports/getClientLocationFulfillmentReport', this.formattedQuery)
          .then(report => {
            this.report = report
          })
          .catch(err => {
            console.log(err);
          })
          .finally(res => {
            this.reportsPending = false;
          });
      },
      reGetRecords: function() {
        this.getReports()
      },
    },
  };
</script>

<style scoped>

</style>
